const { Record } = require('js-data')
const inflection = require( 'inflection' )

module.exports = class PbxxRecord extends Record {
  get database_name() {
    return inflection.transform(this.class_name, ['pluralize', 'underscore'])
  }

  get class_name() {
    return this.constructor.class_name
  }

  get resource_url () {
    let mapper = this._mapper()
    let adaptor = mapper._adapters[mapper.defaultAdapter]
    return `${adaptor.basePath}${this.database_name}/${this.id}/`
  }
}
